import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Header from '../../index/layout/header';
import BottomFooter from '../../index/layout/bottomFooter';
import BackToTop from '../../financeFlash/layout/backToTop';

const getRankClassName = index => {
    if (index === 0) return `${styles.rank} ${styles.rankFirst}`;
    if (index === 1) return `${styles.rank} ${styles.rankSecond}`;
    if (index === 2) return `${styles.rank} ${styles.rankThird}`;

    return styles.rank;
};

const HotList = ({ list = [] }) => {
    if (!list.length) {
        return <div className={styles.emptyTip}>暂无财经热榜数据，请稍后再试</div>;
    }

    return (
        <ul className={styles.list}>
            {list.map((item, index) => (
                <li key={item.id || index} className={styles.item}>
                    <span className={getRankClassName(index)} aria-label={`第 ${index + 1} 名`}>
                        {index + 1}
                    </span>
                    <a href={item.url} className={styles.itemLink} target="_blank" rel="noopener noreferrer">
                        <div className={styles.body}>
                            <div className={styles.itemTitle}>{item.title}</div>
                            {item.summary ? <p className={styles.summary}>{item.summary}</p> : null}
                            {item.time ? (
                                <div className={styles.meta}>
                                    <time className={styles.time}>{item.time}</time>
                                </div>
                            ) : null}
                        </div>
                        {item.thumbnail ? (
                            <div className={styles.thumbBox}>
                                <img className={styles.thumb} src={item.thumbnail} alt="" loading="lazy" />
                            </div>
                        ) : null}
                    </a>
                </li>
            ))}
        </ul>
    );
};

HotList.propTypes = {
    list: PropTypes.array,
};

const Layout = ({ content }) => {
    const { nav, footer, list = [] } = content;

    return (
        <div className={styles.layout}>
            <Header content={nav} />
            <header className={styles.pageHeader}>
                <div className={styles.titleBox}>
                    <a className={styles.logoLink} href="//www.ifeng.com/" aria-label="返回凤凰网首页">
                        <img
                            className={styles.logoImg}
                            src="https://x0.ifengimg.com/ucms/2026_32/C9F6D2AB0A51C6D6B666F70197C7239EDD4F9CCD_size17_w559_h164.png"
                            alt="凤凰网"
                        />
                    </a>
                    <h1 className={styles.pageTitle}>财经热榜</h1>
                    <a className={styles.backLink} href="https://original.ifeng.com/">
                        原创首页
                    </a>
                </div>
            </header>
            <main className={styles.main}>
                <HotList list={list} />
            </main>
            <div className={styles.footerWrap}>
                <BottomFooter content={footer} />
            </div>
            <BackToTop />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
